export const themes = {
  dark: {
    background: '#2C2A2D',
    highlight: '#539560',
    stroke: '#353639',
  },
  light: {
    background: '#D9D9D9',
    highlight: '#539560',
    stroke: '#FFFFFF',
  },
};

export const mapData = {
  Maize: {
    data: [
      {
        state: 'Ogun',
        price: '52,000',
      },
      {
        state: 'Yobe',
        price: '30,000',
      },
      {
        state: 'Sokoto',
        price: '30,000',
      },
      {
        state: 'Kaduna',
        price: '50,000',
      },
    ],
  },
  Cocoa: {
    data: [
      {
        state: 'Imo',
        price: '25,000',
      },
      {
        state: 'Kwara',
        price: '25,000',
      },
      {
        state: 'Enugu',
        price: '35,000',
      },
      {
        state: 'Lagos',
        price: '40,000',
      },
    ],
  },
  'Paddy Rice': {
    data: [
      {
        state: 'Nassarawa',
        price: '20,000',
      },
      {
        state: 'Kwara',
        price: '42,000',
      },
      {
        state: 'Taraba',
        price: '32,000',
      },
      {
        state: 'Kano',
        price: '32,000',
      },
    ],
  },
  Soybeans: {
    data: [
      {
        state: 'Ekiti',
        price: '20,000',
      },
      {
        state: 'Oyo',
        price: '42,000',
      },
      {
        state: 'Kano',
        price: '32,000',
      },
    ],
  },
  Sorghum: {
    data: [
      {
        state: 'Kebbi',
        price: '20,000',
      },
      {
        state: 'Kaduna',
        price: '42,000',
      },
      {
        state: 'Kano',
        price: '32,000',
      },
      {
        state: 'Gombe',
        price: '32,000',
      },
    ],
  },
  Ginger: {
    data: [
      {
        state: 'Adamawa',
        price: '20,000',
      },
      {
        state: 'Kebbi',
        price: '42,000',
      },
      {
        state: 'Kaduna',
        price: '32,000',
      },
    ],
  },
};
